/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Ganturin Vladimir <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'formatSize',
})
export class FormatSizePipe implements PipeTransform {

  transform(bytes: number): string {
    if (bytes < 1) {
      return '';
    }

    const k = 1024;
    const dm = 2;
    const sizes = ['Bytes', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
